import { createContext, useContext } from 'react';
export var FieldContext = createContext({
    readOnly: false,
    addFocusEventForPath: function () {
        // eslint-disable-next-line no-console
        console.warn('addFocusEventForPath was used but not initialized');
    },
});
export var useFieldContext = function () { return useContext(FieldContext); };
